const oper = {
  search: {
    width1: "140px",
    width2: "120px",
    width3: "120px"
  }
} 
export default oper